export enum VitalSignParameterTypeEnum {
    SystolicBp = 1,
    DiastolicBP = 2,
    HeartRate = 3,
    Oximeter = 4,
    Scale = 5,
    Glucose = 6,
}
